import { render, staticRenderFns } from "./BookPanel.vue?vue&type=template&id=37c6099a&"
import script from "./BookPanel.vue?vue&type=script&lang=js&"
export * from "./BookPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports